<template>
    <div class="nav nav-tabs">
        <slot />
    </div>
</template>
